<div class="col-12 causes-section text-center">
  <div class="top-heading">
    <h2>Causes you can raise funds for</h2>
    <p>Be it for a personal need, social cause or a creative idea - you can count on us for <br />the project that you want to raise funds for.</p>
  </div>
  <app-causes-list></app-causes-list>
</div>